import { Config } from '../datasource/config'
import company from './company'
import portal from './portal'

export default Config.fromJS({ portal, company })
